export default "__VITE_ASSET__BArEv__8__"